<template>
    <div class="form-row step-row justify-content-center">
        <div class="col-auto">
            <div class="step-items-wrapper form-row justify-content-center">
                <template v-for="item in items">
                    <div class="step-item col-12" v-bind:key="item.value">
                        <button class="btn step-btn form-control" v-on:click="onclick(item.value)">{{ item.text }}</button>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ButtonList",
        props: {
            items: Array,
            onclick: Function
        }
    }
</script>
